import React, { useEffect, useState } from "react";
import he from "he";
import PromoBanner from "../Components/PromoBanner";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const SupplyingArtwork = () => {
  const [guidelines, setGuidelines] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchGuidelines = async () => {
      setIsLoading(true);

      try {
        const response = await fetch(
          "https://backend.printtrio.co.uk/api/pages/get-guidelines"
        );
        const data = await response.json();

        if (response.ok && data.success) {
          // Decode HTML entities
          let decodedContent = he.decode(data.data[0]?.content || "No content available.");
          
          // Fix malformed image `src` attributes (remove escaped quotes)
          decodedContent = decodedContent.replace(/src=\\"(.*?)\\"/g, 'src="$1"');

          // Add a class to center images
          decodedContent = decodedContent.replace(
            /<img /g,
            '<img class="mx-auto my-4" '
          );

          setGuidelines(decodedContent);
        } else {
          console.error("Failed to fetch guidelines:", data.errors);
          setError("Failed to load guidelines. Please try again later.");
        }
      } catch (error) {
        console.error("Error fetching guidelines:", error);
        setError("An error occurred while loading the guidelines.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchGuidelines();
  }, []);

  return (
    <div>
    <PromoBanner />
    <Navbar />
      {isLoading ? (
        <div className="flex justify-center items-center h-screen">
          {/* Tailwind simple spinner */}
          <svg
            className="animate-spin h-12 w-12 text-pink-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            />
          </svg>
        </div>
      ) : (
        <>
    <section className="px-8 py-12 font-sans text-gray-800 max-w-screen-2xl mx-auto relative">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">
        Supplying Artwork Guidelines
      </h1>
      {error && <p className="text-red-500">{error}</p>}
      {!error && guidelines ? (
        <div
          className="prose max-w-none"
          dangerouslySetInnerHTML={{ __html: guidelines }}
        />
      ) : (
        <p></p>
      )}
    </section>
    <Footer />
    </>
      )}
    </div>
  );
};

export default SupplyingArtwork;
